import { APP_INITIALIZER, ApplicationConfig, EnvironmentProviders, Provider, provideZoneChangeDetection } from '@angular/core';
import { InMemoryScrollingFeature, InMemoryScrollingOptions, provideRouter, withInMemoryScrolling } from '@angular/router';

import { ConfigProjectService } from './services/config.service';
import { ProjectConfigService } from './services/project-config.service';
import { AuthService } from './services/auth.service';
import { register } from 'swiper/element/bundle';
import { DatePipe, DecimalPipe } from '@angular/common';
import { InitializeAppService } from './services/initialize-app.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TokenInterceptorService } from './services/interceptor.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './main.routes';
import { provideLottieOptions } from 'ngx-lottie';
register();

function initializeApp(projectConfigService: ProjectConfigService, authService: AuthService) {
  return async () => {
    await projectConfigService.loadConfig();
    await authService.getUserByToken();
  };
}

const getDynamicProviders = (): (Provider|EnvironmentProviders)[] => {
  const providers: (Provider|EnvironmentProviders)[] = [
    DecimalPipe,
    DatePipe,
    InitializeAppService,
    ConfigProjectService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    provideZoneChangeDetection({ eventCoalescing: true }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ProjectConfigService, AuthService],
      multi: true
    },
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideToastr(),
    provideAnimations(),
    provideAnimationsAsync(),
  ];

  if(!window.__project?.config?.production) {
    console.log('Configuración del proyecto:', window.__project);
  }


  // Añadir GTM solo si existe en la configuración
  if (window.__project?.env?.gtmId) {
    if(!window.__project?.config?.production) {
      console.log('Añadiendo GTM con ID:', window.__project.env.gtmId);
    }
    providers.push({
      provide: 'googleTagManagerId',
      useValue: window.__project?.env?.gtmId
    });
  } else {
    if(!window.__project?.config?.production) {
      console.warn('GTM ID no configurado. Omitiendo proveedor.');
    }
  }

  return providers;
};

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature = withInMemoryScrolling(scrollConfig);

export const createAppConfig = (): ApplicationConfig => {
  return {
    providers: [
      ...getDynamicProviders(),
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideRouter(routes, inMemoryScrollingFeature)
    ]
  };
};
